// extracted by mini-css-extract-plugin
module.exports = {"mt8":"style_mt8__cYuB3","mt6":"style_mt6__BMOKQ"};